module.exports = __webpack_public_path__ + "static/media/DMSans-Regular.d0025c7b.woff";